import { crudTable, index, text } from "@-/dev.improve.haniverse.lib.database.table";

/**
 * A meaning card is identified by its `grapheme`, and its row ids are derived from it
 * (`deriveGraphemeMeaningCardRowIds`), so two devices that create the card before they sync create
 * the same rows. That is why no unique index guards `grapheme` or `user_card_id`: sync cannot
 * resolve a unique conflict, so the duplicate is made impossible instead.
 */
export const userGraphemeMeaningCardTable = crudTable(
  "user_grapheme_meaning_card",
  {
    // A parent id, not a FOREIGN KEY: see `ACTOR_TABLE_PARENTS` (the cloud copy would enforce one).
    userCardId: text("user_card_id").notNull(),
    /** User-authored mnemonic; null means use catalog default */
    description: text("description"),
    grapheme: text("grapheme").notNull(),
  },
  // `userCardId` backs the `userCard.userGraphemeMeaningCard` relation join; `grapheme` backs the
  // `findFirst({ where: { grapheme } })` lookups (upsert / reset / preset flows).
  (table) => [
    index("user_grapheme_meaning_card_grapheme_idx").on(table.grapheme),
    index("user_grapheme_meaning_card_user_card_id_idx").on(table.userCardId),
  ],
);

export type UserGraphemeMeaningCard = typeof userGraphemeMeaningCardTable.$inferSelect;
